import React from 'react';
import clsx from 'clsx';

import './index.scss';

const PcErrorArea = ({ message, position = 'absolute', message2row = false }) => {

  return (
    <div className={clsx(
      'PcErrorArea',
      { noError: !message },
      { error: !!message },
      { custom: position === 'custom' },
      { absolute: position === 'absolute' },
      { relative: position === 'relative' },
      { message2row }
    )}
    >
      <div className="M-EA-message">
          <span className="redCircle">！</span>
          <span className="errText">{message}</span>
      </div>
    </div>
  );
};

export default PcErrorArea;